import React, { Component } from 'react';

import { inject, observer } from 'mobx-react';

class SessionListing extends Component {

  render() {
    const courseIconUrl = 'https://my.kabbalah.com/ticket-widget/media/session-icon.png';
    const { store, courseId, sessionId } = this.props;  
    const course = store.courses[courseId];
    const session = course.sessions[sessionId];    
    return (
      <li className="list-group-item">
        <div className="container">
          <div className="row align-items-center">
            <div className="col-lg-1 d-none d-lg-block text-center">
              <img width="50px" src={courseIconUrl} alt="" />
            </div>
            <div className="col-10 col-lg-3">
              <p>
                <span className="d-inline d-lg-none font-weight-light">Session:&nbsp;</span>
                {session.Name}              
              </p>            
            </div>
            <div className="col-2 d-block d-lg-none text-right align-self-start">
              <img width="50px" src={courseIconUrl} alt="" />
            </div>            
            <div className="col-12 col-lg-5 text-lg-left">
              <p>
                <span className="d-inline d-lg-none font-weight-light">Date/Time:&nbsp;</span>
                {session.Start_Time__c + ' ' + course.Start_Time__c} 
                <br />
                <span className="small">{course.Time_Zone__c}</span>               
              </p>
            </div>
            <div className="col-xs-12 col-sm-10 col-md-8 col-lg-3 text-lg-center">
              {session.Meeting_Link__c &&
                <p>                                      
                  <a href={session.Meeting_Link__c} target="_blank">
                    <button                         
                      className="btn btn-block btn-danger"                         
                    >
                      Attend Online                
                    </button>	                    
                  </a>                  
                </p>
              }
              {!session.Meeting_Link__c &&
                <p>                                      
                    <button                         
                      className="btn btn-block btn-danger"
                      disabled                         
                    >
                      Webcast Pending                
                    </button>	                                  
                    <small className="font-italic">
                      The webcast has not started. 
                      Please return at the designated date/time.
                    </small>
                </p>                
              }              
            </div>            
          </div>
        </div>
      </li>
    );
  }

}

export default inject('store')(observer(SessionListing));



// WEBPACK FOOTER //
// ./src/components/SessionListing.js